import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { ApiConectateService } from '../../../../api/apiConectate';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [TranslatePipe, TranslateDirective, ReactiveFormsModule],
  selector: 'sas-invite-participants',
  templateUrl: './invite-participants.component.html',
  styleUrls: ['./invite-participants.component.scss']
})
export class InviteParticipantsComponent implements OnInit {
  public inviteForm?: FormGroup;
  @Output() closeFormTooltip: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly apiConectateSvc: ApiConectateService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }
  public sendInvitation() {
    if (this.inviteForm && !this.inviteForm.invalid) {
      this.apiConectateSvc.sendInvitation(this.inviteForm).subscribe(
        res => this.closeForm(),
        error => {
          // Handle error scenario
          console.error('Error sending invitation:', error);
        }
      );
    }
  }

  public closeForm() {
    this.closeFormTooltip.emit(false);
  }

  private initForm() {
    this.inviteForm = this.formBuilder.group({
      name: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.pattern(/^(?!.*\.\.)[a-zA-Z0-9](?:[a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/)])
    })
  }

}
